import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Subheading from "../Common/Subheading";
import ProductsIcon from "../../assets/icons/docs.svg2";

export default function ProductsLandingPage() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleLearnMoreClick = (event, product) => {
    event.preventDefault();
    event.stopPropagation();
    window.location.assign(product.link);
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
  };

  const products = [
    {
      name: "Solutions",
      description:
        "A world of ready to use communication workflows built for your needs",
      picture: "/assets/products/images/solutionscard.png",
      link: "/workflows/products/solutions",
    },
    {
      name: "BoomLogic",
      description:
        "A simple, no-code business process builder for bespoke projects.",
      picture: "/assets/products/images/logic.png",
      link: "/workflows/products/boomlogic",
    },

    {
      name: "BoomAI",
      description:
        "Enterprise-level artificial intelligence that automates insight, decisions and outcomes.",
      link: "/workflows/products/boomai",
      picture: "/assets/products/images/ai.png",
    },
    {
      name: "BoomMail",
      description:
        "Email-to-SMS and email-to-voice interactive messaging, delivered via email.",
      link: "/workflows/products/boommail",
      picture: "/assets/products/images/mail.png",
    },
    {
      name: "Broadcast Messaging",
      description:
        "Mass broadcasting of one-way and two-way omni-channel messaging.",
      link: "/workflows/products/broadcastMessaging",
      picture: "/assets/products/images/broadcast.png",
    },
    {
      name: "Campaign",
      description:
        "Drive inbound engagement and initiate communication campaigns.",
      link: "/workflows/products/campaign",
      picture: "/assets/products/images/campaign.png",
    },
    {
      name: "API's plugins and Apps",
      description:
        "We want to make it easy for organisations like yours to work with us",
      link: "/workflows/products/apisPluginsandApps",
      picture: "/assets/products/images/api.png",
    },
    {
      name: "Weather monitoring and alerting",
      description: "Be prepared for business disruption and keep staff safe",
      link: "/workflows/products/weatherMonitoringAndAlerting",
      picture: "/assets/products/images/weather.png",
    },
    {
      name: "Asset management",
      description:
        "Easily track and communicate with contacts associated with assets",
      link: "/workflows/products/assetManagement",
      picture: "/assets/products/images/asset.png",
    },
    {
      name: "Monitoring and Alerting",
      description:
        "Connect to and react to alerts based on predefined monitoring and workflows",
      link: "/workflows/products/monitoringAndAlerting",
      picture: "/assets/products/images/monalert.png",
    },
    {
      name: "Events and Alerting",
      description:
        "Identify, react and inform as quickly and efficiently as possible",
      link: "/workflows/products/eventsAndAlerting",
      picture: "/assets/products/images/eventsalert.png",
    },
    {
      name: "Professional Builder",
      description:
        "Build it, test it, try it, buy it….you will be amazed at what is possible",
      link: "/workflows/products/professionalBuilder",
      picture: "/assets/products/images/buildercard.png",
    },
  ];

  return (
    <>
      <div className="flex-grow-1 ms-3">
        <Subheading Icon={ProductsIcon} heading="Products" subheading="." />
      </div>
      <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 mb-5">
        <div className="fw-bold text-navy text-center fs-2">
          Products and Services available
        </div>
        <div>
          <p className="text-center fs-5 mt-3">
            Boomerang has an assortment of products and services that can be
            used for a range of capabilities from messaging to dynamic
            workflows, from asset management to weather alerting. Please take a
            look and feel free to explore the many services Boomerang provides
          </p>
        </div>
      </div>

      <div className="card-light-gradient rounded-4 text-navy p-4 position-relative d-flex flex-column">
        <div className="fw-bold text-center fs-2 mb-4">
          Explore our products and services
        </div>
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4">
          {products.map((product) => (
            <div key={product.link} className="col">
              {/* <a
                href={product.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none text-navy d-block h-100"
              > */}
                <div className="card-light-gradient rounded-4 p-3 h-100 d-flex flex-column justify-content-between align-items-center">
                  <img
                    src={product.picture}
                    alt={product.name}
                    className="w-50 rounded-3 mb-3"
                    style={{ height: "100px", objectFit: "cover" }}
                  />
                  <div>
                    <div className="fw-bold fs-5 d-flex justify-content-center">{product.name}</div>
                    <div className="fs-6 mt-2 text-black">
                      {product.description}
                    </div>
                  </div>
                  <Button
                    className="bg-colored-reverse fw-bold border-0 rounded-3 mt-3" 
                    onClick={(event) => handleLearnMoreClick(event, product)}
                  >
                 <a href={product.link} target="_blank" rel="noopener noreferrer" className="text-white text-decoration-none">Learn More</a>
                  </Button>
                </div>
              {/* </a> */}
            </div>
          ))}
        </div>
      </div>

      <Modal show={Boolean(selectedProduct)} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedProduct?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>For more information please contact our support team.</div>
          <div className="my-2">Call us at +44(0)207 224 5555</div>
          <div className="d-flex gap-1 my-2">
            <div>Email us at</div>
            <div>
              <div>
                {" "}
                <a href="mailto:support@boomcomms.com">support@boomcomms.com</a>
              </div>
              <div>
                {" "}
                <a href="mailto:sales@boomcomms.com">sales@boomcomms.com</a>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end gap-2 p-3">
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
